import { IconWithColor } from '@aibees/shared/definition/metadata';

export const coloredIcons: Record<string, IconWithColor> = {
  company: {
    icon: 'business',
    color: '#1851ef',
  },
  people: {
    icon: 'people-outline',
    color: '#039855',
  },
  department: {
    icon: 'people-outline',
    color: '#039855',
  },
};
